import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import GroupBadge from 'flarum/common/components/GroupBadge';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';
import Icon from 'flarum/common/components/Icon';
import { field, section, locked, note } from './Field';
import { PasswordModal, EmailModal } from './AccountModals';
import OtherSettings from './OtherSettings';
import AvatarGalleryModal from './AvatarGalleryModal';
import * as NickRules from '../utils/nickRules';

/** «Мобильные устройства» only where vibration works: Vibration API + a touch screen (not desktop, not iPhone). */
export function hasVibration() {
  try {
    return typeof navigator !== 'undefined' && 'vibrate' in navigator && !!window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  } catch (e) {
    return false;
  }
}
const t = (key, params) => app.translator.trans('ppk2-profile.forum.' + key, params);

/** a.b@example.com -> a***@example.com */
export function maskEmail(email) {
  if (!email || email.indexOf('@') < 1) return email || '';
  const [name, domain] = email.split('@');
  return name.charAt(0) + '***@' + domain;
}
export function inDevelopment() {
  app.alerts.show({
    type: 'info'
  }, t('common.in_development'));
}

/**
 * Tab «Основная». Attrs: user, state ({ alt1, alt2, discloseOnline } streams), loading.
 */
export default class MainTab extends Component {
  /** Local problem for twink n (format, or same as the other twink / own main nick). */
  localError(n) {
    const s = this.attrs.state;
    const nick = NickRules.normalize(s['alt' + n]());
    if (nick === null) return null;
    const format = NickRules.check(nick);
    if (format) return format;
    const other = NickRules.normalize(s['alt' + (n === 1 ? 2 : 1)]());
    if (n === 2 && other === nick || this.attrs.user.attribute('ppk2MainNick') === nick) {
      return [NickRules.KEY + 'duplicate_own', {}];
    }
    return null;
  }
  twinkInput(n) {
    const s = this.attrs.state;
    const value = s['alt' + n]();
    const local = this.localError(n);
    const result = s['result' + n];
    let status = null;
    if (local) status = {
      status: 'invalid',
      message: app.translator.trans(local[0], local[1])
    };else if (result) status = result;
    return m("div", {
      className: "Ppk2NickInput"
    }, m("input", {
      className: 'FormControl' + (status ? ' Ppk2NickInput--' + status.status : ''),
      name: 'ppk2AltNick' + n,
      maxlength: "32",
      autocomplete: "off",
      spellcheck: "false",
      placeholder: t('main.twinks.placeholder_' + n),
      value: value,
      oninput: e => {
        s['alt' + n](e.target.value);
        s.result1 = s.result2 = null;
      },
      disabled: this.attrs.loading
    }), status ? m("div", {
      className: 'Ppk2NickStatus Ppk2NickStatus--' + status.status
    }, m(Icon, {
      name: status.status === 'free' ? 'fas fa-circle-check' : 'fas fa-circle-xmark'
    }), " ", status.message) : null);
  }
  checkNicks() {
    const s = this.attrs.state;
    const toSend = [];
    [1, 2].forEach(n => {
      s['result' + n] = null;
      const nick = NickRules.normalize(s['alt' + n]());
      if (nick !== null && !this.localError(n)) toSend.push([n, nick]);
    });
    if (!toSend.length) return;
    s.checking = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/ppk2/nick-check',
      body: {
        nicks: toSend.map(([, nick]) => nick)
      }
    }).then(response => {
      toSend.forEach(([n], i) => {
        const r = response.results[i];
        s['result' + n] = {
          status: r.status,
          message: r.message
        };
      });
    }).finally(() => {
      s.checking = false;
      m.redraw();
    });
  }
  view() {
    const user = this.attrs.user;
    const s = this.attrs.state;
    const requestButton = key => m(Button, {
      type: "button",
      className: "Button Ppk2RequestButton Ppk2IconOnPhone",
      icon: "fas fa-pen-to-square",
      title: t('buttons.request_change'),
      "aria-label": t('buttons.request_change'),
      onclick: inDevelopment,
      "data-request": key
    }, t('buttons.request_change'));
    const changeButton = (key, onclick) => m(Button, {
      type: "button",
      className: "Button Ppk2RequestButton Ppk2IconOnPhone",
      icon: "fas fa-pen",
      title: t('account.change'),
      "aria-label": t('account.change'),
      onclick: onclick,
      "data-change": key,
      disabled: this.attrs.loading
    }, t('account.change'));
    const groups = (user.groups() || []).filter(Boolean);
    const joined = user.joinTime();
    return m("div", {
      className: "Ppk2Tab Ppk2Tab--main"
    }, section(t('main.section_profile')), field('avatar', t('main.avatar.label'), m("div", {
      className: "Ppk2AvatarRow"
    }, m(AvatarEditor, {
      user: user,
      className: "Ppk2AvatarEditor"
    }), m(Button, {
      type: "button",
      className: "Button",
      icon: "fas fa-image",
      onclick: e => {
        // Hand the click to the core AvatarEditor: no avatar -> file picker,
        // has avatar -> its Upload / Remove menu. Native click keeps the user gesture.
        e.stopPropagation();
        const toggle = this.element.querySelector('.Ppk2AvatarEditor .Dropdown-toggle');
        if (toggle) toggle.click();
      }
    }, t('buttons.change_avatar')), m(Button, {
      type: "button",
      className: "Button Ppk2AvatarGalleryButton",
      icon: "fas fa-images",
      title: t('avatar_gallery.button_tip'),
      onclick: () => app.modal.show(AvatarGalleryModal, {
        user
      })
    }, t('avatar_gallery.button'))), null, t('main.avatar.tip')), field('username', t('main.username.label'), locked(user.username()), requestButton('username'), t('main.username.tip')), field('email', t('main.email.label'), locked(maskEmail(user.email())), changeButton('email', () => app.modal.show(EmailModal)), t('account.immediate_tip')), field('password', t('account.password_label'), locked('••••••••'), changeButton('password', () => app.modal.show(PasswordModal)), t('account.immediate_tip')), field('mainNick', t('main.main_nick.label'), locked(user.attribute('ppk2MainNick') || t('main.main_nick.not_set'), !user.attribute('ppk2MainNick')), requestButton('mainNick'), t('main.main_nick.tip')), field('twinks', t('main.twinks.label'), [this.twinkInput(1), this.twinkInput(2), note(t('common.only_you'))], m(Button, {
      type: "button",
      className: "Button Ppk2CheckButton Ppk2IconOnPhone",
      title: t('main.twinks.check_button'),
      "aria-label": t('main.twinks.check_button'),
      icon: "fas fa-spell-check",
      loading: s.checking,
      disabled: this.attrs.loading || !NickRules.normalize(s.alt1()) && !NickRules.normalize(s.alt2()),
      onclick: () => this.checkNicks()
    }, t('main.twinks.check_button')), m("span", {
      className: "Ppk2Tip-multiline"
    }, t('main.twinks.tip', {
      chars: NickRules.SPECIAL_CHARS
    }))), section(t('main.section_service')), field('groups', t('main.groups.label'), m("div", {
      className: "Ppk2Chips"
    }, groups.length ? groups.map(group => m("span", {
      className: "Ppk2Chip Ppk2Chip--group",
      title: t('main.groups.badge_tip', {
        name: group.nameSingular()
      })
    }, m(GroupBadge, {
      group: group,
      label: null
    }), m("span", null, group.nameSingular()))) : m("span", {
      className: "Ppk2Muted"
    }, t('main.groups.none'))), requestButton('groups'), t('main.groups.tip')), field('ranks', t('main.ranks.label'), [m("span", {
      className: "Ppk2Muted"
    }, t('common.in_development')), note(t('main.ranks.assigned_by_mods'))], null, t('main.ranks.tip')), section(t('main.section_activity')), field('joined', t('main.joined.label'), m("div", {
      className: "Ppk2Value"
    }, joined ? dayjs(joined).format('LL') : ''), null, t('main.joined.tip')), section(t('account.section_privacy')), field('online', t('main.online.label'), m(Switch, {
      state: s.discloseOnline(),
      onchange: value => s.discloseOnline(value),
      disabled: this.attrs.loading
    }, t('main.online.switch')), null, t('main.online.tip')), hasVibration() && section(t('main.section_mobile')), hasVibration() && field('haptic', t('main.haptic.label'), m(Switch, {
      state: s.hapticFeedback(),
      onchange: value => s.hapticFeedback(value),
      disabled: this.attrs.loading
    }, app.translator.trans('core.forum.settings.haptic_feedback_label'), m("span", {
      className: "helpText"
    }, app.translator.trans('core.forum.settings.haptic_feedback_help'))), null, t('main.haptic.tip')), m(OtherSettings, {
      user: user,
      heading: section(t('account.section_other'))
    }));
  }
}
flarum.reg.add('ppk2-profile', 'forum/components/MainTab', MainTab);